import { Box, Container, Link, Typography } from '@mui/material';
import { AuthorizationUser } from '@price-for-profit/micro-services';
import { useWatch } from 'react-hook-form';
import { Link as RouterLink } from 'react-router-dom';
import { ROUTES } from 'routing';
import { AppForm, FormSubmitButton } from 'shared/components';
import { useCreateUserMapping } from 'shared/mutations';
import { Commodity, UserInfo, UserMapping } from 'shared/types';
import { commodityToUserMapping } from 'shared/utility';
import { CommoditiesDropdown } from './commodities-dropdown';
import { UserDropdown } from './user-dropdown';

interface UserMappingForm {
  user: AuthorizationUser | null;
  commodities: Commodity[];
}

interface UserMappingCreatePageProps {
  user: UserInfo;
}

const DEFAULT_USER_MAPPING_FORM: UserMappingForm = {
  user: null,
  commodities: [],
};
export function UserMappingCreatePage({ user }: UserMappingCreatePageProps) {
  const createMutation = useCreateUserMapping();
  const submit = async (form: UserMappingForm) => {
    if (form.user) {
      const isoCurrentDate = new Date().toISOString();
      const userMapping: UserMapping = {
        id: form.user.id,
        name: form.user.displayName,
        email: form.user.email,
        createdBy: user.id,
        createdDate: isoCurrentDate,
        createdByEmail: user.email,
        updatedBy: user.displayName,
        updatedDate: isoCurrentDate,
        updatedByEmail: user.email,
      };
      const commodities = form.commodities.map(
        commodityToUserMapping({
          userMappingId: form.user.id,
          createdBy: user.id,
          createdDate: isoCurrentDate,
          createdByEmail: user.email,
        })
      );

      await createMutation.mutateAsync({ userMapping, commodities });
    }
  };
  return (
    <Container sx={{ p: 2, height: 'calc(100vh - 125px)' }}>
      <Box sx={{ pb: 2 }}>
        <Link underline='none' component={RouterLink} to={ROUTES.userMapping}>
          Back to User Mapping List
        </Link>
      </Box>
      <AppForm id='user-mapping-edit-form' defaultForm={DEFAULT_USER_MAPPING_FORM} onSubmit={submit}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
          <Typography variant='h5'>Create New User Mapping</Typography>
          <MappingFields />
          <FormSubmitButton defaultForm={DEFAULT_USER_MAPPING_FORM} />
        </Box>
      </AppForm>
    </Container>
  );
}

function MappingFields() {
  const user = useWatch({ name: 'user' });

  return (
    <>
      <UserDropdown />
      {Boolean(user) && <CommoditiesDropdown />}
    </>
  );
}
